import { createTheme } from '@mui/material/styles'
import { baseThemeOptions } from './baseTheme'
import { lightPalette } from './palette'

/**
 * Light theme configuration.
 * Extends baseTheme with light palette colors.
 */
export const lightTheme = createTheme({
    ...baseThemeOptions,
    palette: {
        mode: 'light',
        ...lightPalette,
    },
})
